import React from 'react';
import { useClassNames } from '../../hooks/useClassNames';

/**
 * A reusable card component that provides consistent styling across the application.
 * Supports both light and dark modes using Tailwind's dark mode classes.
 */
export const Card = ({
  children,
  title,
  subtitle,
  icon: Icon,
  className = '',
  headerClassName = '',
  bodyClassName = '',
  headerBorder = true,
  hover = true,
  removeBodyXPadding = false,
  removeBottomPadding = false,
  headerActions = null
}) => {
  const { classNames } = useClassNames();

  return (
    <div className="pb-6">
      <div className={classNames(
        'bg-white dark:bg-gray-700 rounded-lg shadow dark:shadow-gray-700/25',
        hover ? 'transition-all duration-200 hover:shadow-lg dark:hover:shadow-gray-700/50' : '',
        className
      )}>
        <CardHeader title={title} subtitle={subtitle} headerBorder={headerBorder} headerActions={headerActions} headerClassName={headerClassName} />
        <div className={classNames(
          removeBodyXPadding ? '' : 'px-4 sm:px-6',
          removeBottomPadding ? `pt-4 ${bodyClassName}` : `py-4 ${bodyClassName}`,
        )}>
          {children}
        </div>
      </div>
    </div>
  );
};

export const CardHeader = ({ title = '', icon: Icon = null, subtitle = '', headerBorder = true, headerClassName = '', headerActions = null }) => {

  const { classNames } = useClassNames();

  return (
    (title || subtitle) && (
      <div className={classNames(
        'px-4 sm:px-6 py-4 sm:py-5',
        headerBorder ? 'border-b border-gray-100 dark:border-gray-500' : '',
        headerClassName
      )}>
        <div className="flex justify-between items-start">
          <div>
            <h3 className="text-lg font-medium leading-6 text-gray-800 dark:text-white flex items-center">
              {Icon && <Icon className="h-5 w-5 mr-2 text-indigo-500 dark:text-indigo-400" />}
              {title}
            </h3>
            {subtitle && (
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                {subtitle}
              </p>
            )}
          </div>
          {headerActions && (
            <div className="ml-4">
              {headerActions}
            </div>
          )}
        </div>
      </div>
    )
  )
}

export default Card;